module.exports = __webpack_public_path__ + "media/images/flags/LY-44483c0995dbeba906418ece975a6983.svg";